<template>
<div class="loginClass" :style="loginClass">
	<video class="bgVideo" autoplay="autoplay" loop='loop' muted>
	  <source src="https://oss.kmyhwy.cn/web/login_bg.mp4" type="video/mp4">
	</video>
  <!-- <img src="../../assets/imgs/bg2.jpg" class="background" width="100%" height="100%" alt="" /> -->
  <span style="float: left;margin-left: 20px;margin-top: 20px; position: fixed;">
    <img src="../../assets/imgs/logos.png" width="150px" height="84px"/>
  </span>
  <el-card class="login-card">
      <div class="blue"></div>
      <p>{{$t('lang.lab_conpanyName')}}</p>
      <div class="line2"></div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="name" label-width='32px'>
          <el-input v-model="ruleForm.name" :placeholder="this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_account')" class="inputext1"></el-input>
        </el-form-item>
        <el-form-item prop="password" label-width='32px'>
          <el-input v-model="ruleForm.password" type="password" :placeholder="this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_password')" class="inputext2"></el-input>
        </el-form-item>
      <el-button type="primary" @click="login('ruleForm')" class="btn1">{{$t('lang.lab_login')}}</el-button>
      </el-form>
  </el-card>
  <!-- 杜，新增底部备案号组件 -->
    <div class="loginBottom">
      <Foot-bottom></Foot-bottom>
    </div>
</div>
</template>

<script>
/**
 *@ClassName:loginClass
 *@Description:登录
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-03-06
 */
 import FootBottom from '../../components/footBottom'
 import { changeThemeColor } from '@/config/themeColorClient'
export default {
  // import引入的组件需要注入到对象中才能使用
  name: 'login',
  components: { FootBottom },
  data() {
    // 这里存放数据
    return {
      name: '', // 用户名
      password: '', // 密码
      loginClass: {
        // backgroundImage: 'url(' + require('../../assets/imgs/bg2.jpg') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        overflow: 'hidden',
        width: '100%',
        height: '100%',
      }, // 用于样式
      ruleForm: {
        name: '',
        password: '',
      }, // 用户名密码
      rules: {
        name: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + '账号', trigger: 'blur' }],
        password: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + '密码', trigger: 'blur' }],
      }, // 表单验证
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化d
  watch: {},
  // 方法集合
  methods: {
    // 监听回车事件
    listenEnter() {
      var _this = this
      document.onkeydown = function(e) {
        let key = window.event.keyCode
        if (key == 13) {
          _this.login('ruleForm')
        }
      }
    },
    login(formName) {
     this.$refs[formName].validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          let params = {
            userName: this.ruleForm.name,
            password: this.ruleForm.password,
          }
          this.$post(`/auths`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                res.account = params.userName
                res.password = params.password
                this.$store.commit('user/setUserData', res)

                // Bug #8452
                let color = []
                color = res.style.split(',')
                if (color.length > 1) {
                  let style = {
                    top: color[0],
                    bottom: color[1]
                  }
                  changeThemeColor(style.top)
                    .then(() => {
                      console.log('主题色切换成功~')
                      this.$store.commit('theme/setTheme', style)
                    })
                }
                this.$router.push({ path: '/manage' })
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 解决
    evil(fn) {
      let Fn = Function // 一个变量指向Function，防止有些前端编译工具报错
        return new Fn('return ' + fn)()
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.listenEnter()
  },
}
</script>

<style lang='scss'>
	.bgVideo{
	  position: fixed;
	  right: 0px;
	  bottom: 0px;
	  min-width: 100%;
	  min-height: 100%;
	  width: 100vw;
	  height: auto;
	  object-fit: cover;
	}
.loginBottom{
  width:100%;position:absolute;left:0;bottom:0;
}
.loginBottom .bottomRecordNum{
    text-align: center;
    padding: 10px 0;
    background-color: transparent;
    color: #fff;
  }
  .loginBottom .bottomRecordNum a{
    color: #fff;
  }
.loginClass{
  .el-card {
    border: 0px solid #EBEEF5 !important;
    padding: 0px !important;; 
    border-radius: 0px !important;;
  }
  .background{
      width:100%;  
      height:100%;  /**宽高100%是为了图片铺满屏幕 */
      z-index:-1;
      position: absolute;
  }
}
.login-card {
  background-color:rgba(255, 255, 255, 0.2) !important;
  width: 400px;
  height: 440px;
  z-index:1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  .blue {
    background-color:#095edf;
    height: 8px;
    width: 400px;
    margin-top: 0px;
  }
 .line2{
    border-bottom:2px solid #999999;
    height: 24px;
    margin-left: 32px;
    margin-right: 32px;
  }
  .inputext1 {
    margin-top: 45px;
    width: 334px;
    height: 42px;
    z-index: 999;
    opacity: 1!important; 
  }
  .inputext2 {
    margin-top: 20-20px;
    width: 334px;
    height: 42px;
    z-index: 999;
    opacity: 1!important; 
  }
  .btn1 {
    background-color:#095edf;
    border: 0px solid #DCDFE6;
    margin-top: 60-20px;
    margin-left: 32px;
    margin-bottom: 80px;
    width: 334px;
    height: 42px;
    z-index: 999;
    opacity: 1!important; 
  }
  p{
    color: white;
    margin-top: 48px;
    font-size: 18px;
    text-align: center;
    opacity: 1!important; 
  }
}
</style>